const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN_KEY';
const SERVICE_ID_KEY = 'SERVICE_ID_KEY';

export const setAccessToken = (accessToken: string): void => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
};

export const clearAccessTokens = (): void => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, '');
};

export const getAccessToken = (): string => {
  return window.localStorage.getItem(ACCESS_TOKEN_KEY) || '';
};

export const setServiceId = (serviceId: string): void => {
  window.localStorage.setItem(SERVICE_ID_KEY, serviceId);
};

export const getServiceId = (): string => {
  return window.localStorage.getItem(SERVICE_ID_KEY) || '';
};

export const clearServiceId = (): void => {
  window.localStorage.setItem(SERVICE_ID_KEY, '');
};
